import { reactive } from 'vue';

class Breakpoint {
  constructor() {
    this.breakpoint = reactive({
      // Dimensions
      height: null,
      width: null,

      // Breakpoints
      xs: null,
      sm: null,
      md: null,
      lg: null,
      xl: null,
      xl2: null,

      // Conditionals
      xsOnly: null,
      smOnly: null,
      smAndDown: null,
      smAndUp: null,
      mdOnly: null,
      mdAndDown: null,
      mdAndUp: null,
      lgOnly: null,
      lgAndDown: null,
      lgAndUp: null,
      xlOnly: null,
      xlAndDown: null,
      xlAndUp: null,
      xl2Only: null,
    });

    this.resizeTimeout = null;

    this.update();

    window.addEventListener('resize', this.onResize.bind(this), { passive: true });
  }

  /** @return {object} */
  getData() {
    return this.breakpoint;
  }

  /** @return {void} */
  onResize() {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
  }

  /** @return {void} */
  update() {
    const height = document.documentElement.clientHeight;
    const width = document.documentElement.clientWidth;

    const xs = width < 640;
    const sm = width >= 640 && width < 768;
    const md = width >= 768 && width < 1024;
    const lg = width >= 1024 && width < 1280;
    const xl = width >= 1280 && width < 1536;
    const xl2 = width >= 1536;

    this.breakpoint.height = height;
    this.breakpoint.width = width;

    this.breakpoint.xs = xs;
    this.breakpoint.sm = sm;
    this.breakpoint.md = md;
    this.breakpoint.lg = lg;
    this.breakpoint.xl = xl;
    this.breakpoint.xl2 = xl2;

    this.breakpoint.xsOnly = xs;
    this.breakpoint.smOnly = sm;
    this.breakpoint.smAndDown = xs || sm;
    this.breakpoint.smAndUp = sm || md || lg || xl || xl2;
    this.breakpoint.mdOnly = md;
    this.breakpoint.mdAndDown = xs || sm || md;
    this.breakpoint.mdAndUp = md || lg || xl || xl2;
    this.breakpoint.lgOnly = lg;
    this.breakpoint.lgAndDown = xs || sm || md || lg;
    this.breakpoint.lgAndUp = lg || xl || xl2;
    this.breakpoint.xlOnly = xl;
    this.breakpoint.xlAndDown = xs || sm || md || lg || xl;
    this.breakpoint.xlAndUp = xl || xl2;
    this.breakpoint.xl2Only = xl2;
  }
}

export default {
  install(app) {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$breakpoint = (new Breakpoint()).getData();
  },
};
